const ready = (fn) => {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => fn(), { once: true });
	} else {
		fn();
	}
};

const q  = (root) => (sel) => root.querySelector(sel);
const qa = (root) => (sel) => Array.from(root.querySelectorAll(sel));

// COMMON
function runCommon(root = document) {
	try {
		const ctx = require.context('./common', false, /\.js$/);

		ctx.keys().forEach((k) => {
			try {
				const mod  = ctx(k);
				const init = (mod && (mod.default || mod.init)) || null;

				// run side-effect modules
				if (typeof init === 'function') {
					init(root);
				}
			} catch (e) {
				if (process.env.NODE_ENV !== 'production') {
					console.error(`[common] Error in ${k}`, e);
				}
			}
		});
	} catch (e) {
		if (process.env.NODE_ENV !== 'production') {
			console.error('[common] Failed to init common modules', e);
		}
	}
}

// DATA-MODULES (data-module="a b c")
function runModules(root = document) {
	const ctx = (root && typeof root.querySelectorAll === 'function') ? root : document;
	const nodes = ctx.querySelectorAll('[data-module]');
	nodes.forEach((el) => {
		const list = (el.getAttribute('data-module') || '')
			.split(/\s+/).map(s => s.trim()).filter(Boolean);

		list.forEach((name) => {
			import(/* webpackChunkName: "mod-[request]-js" */ `./modules/${name}.js`)
				.then((m) => {
					const init = (m && m.default) || m?.init;
					if (typeof init === 'function') init(el, q(el), qa(el));
				})
				.catch(() => {});
		});
	});
}

// SECTIONS
function runSections() {
	try {
		const ctx = require.context('./sections', false, /\.js$/);
		ctx.keys().forEach((k) => {
			const mod = ctx(k);
			const selector = mod.sectionSelector;
			const cb = mod.sectionCallBack;
			if (!selector || typeof cb !== 'function') return;
			document.querySelectorAll(selector).forEach((root) => cb(root, q(root), qa(root)));
		});
	} catch {}
}

// BOOT
function boot(root = document) {
	const ctx = (root && typeof root.querySelectorAll === 'function') ? root : document;
	runCommon();
	runModules(ctx);
	runSections();
}

ready(boot);
window.ajustBoot = () => boot(document);
